/**
 * Formats a phone number to display as (XXX) XXX-XXXX
 * @param {string} phone - The phone number to format
 * @returns {string} - Formatted phone number or original if invalid
 */
export function formatPhoneNumber(phone) {
  if (!phone) return phone;
  
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  
  // Check if it's a valid 10-digit US phone number
  if (digits.length === 10) {
    const areaCode = digits.slice(0, 3);
    const exchange = digits.slice(3, 6);
    const number = digits.slice(6, 10);
    return `(${areaCode}) ${exchange}-${number}`;
  }
  
  // If it's 11 digits and starts with 1, treat as 1-XXX-XXX-XXXX
  if (digits.length === 11 && digits[0] === '1') {
    const areaCode = digits.slice(1, 4);
    const exchange = digits.slice(4, 7);
    const number = digits.slice(7, 11);
    return `(${areaCode}) ${exchange}-${number}`;
  }
  
  // Return original if we can't format it
  return phone;
}
